

import { ConfirmSubtitlesWordSubstitutionModal } from './component'



export default ConfirmSubtitlesWordSubstitutionModal


